<template>
  <div class="addon-item">
    <div
      @click="onEdit"
      class="addon-item__header"
      :style="{
        'border-bottom-left-radius': this.open ? 0 : '3px',
        'border-bottom-right-radius': this.open ? 0 : '3px'
      }"
    >
      <div class="addon-item__header-title">{{ title }}</div>
      <div class="addon-item__header-actions">
        <!-- <el-button size="mini" type="text" @click="onEdit">
          Edit
          <i class="el-icon-setting"></i>
        </el-button>-->
        <el-button size="mini" type="text" @click.stop="onDelete">
          Delete
          <i class="el-icon-delete"></i>
        </el-button>
      </div>
    </div>
    <div class="addon-item__body" v-if="open">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddonItem',

  props: {
    title: String,
    name: String
  },

  data () {
    return {
      open: false
    }
  },

  computed: {
    isSlot () {
      return this.$slots.default
    }
  },

  methods: {
    onEdit () {
      this.open = !this.open
    },
    onDelete () {
      this.$store.dispatch('removeAddon', this.name)
    }
  }
}
</script>

<style lang="scss">
.addon-item {
  &__header {
    display: grid;
    grid-template-columns: 2fr 1fr;
    border: 1px solid #e4e7ed;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    background-color: #f2f6fc;
    padding: 10px 15px;
    align-items: center;
    cursor: pointer;
    &-actions {
      text-align: right;
    }
  }
  &__body {
    border: 1px solid #e4e7ed;
    border-top: none;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
    padding: 15px;
  }
  + .addon-item {
    margin-top: 10px;
  }
}
</style>
